import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, MapPin, ShieldCheck, Star } from 'lucide-react';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/69cd4c5f-009a-4404-84b1-f3403f7b5722.jpg';
export function Hero() {
  return <section id="top" className="relative overflow-hidden bg-ink" data-id="element-116" data-mp="enfexrw2b4oo">
      <img src={HERO_IMAGE} alt="Restored Colorado craftsman home lit at dusk" className="absolute inset-0 h-full w-full object-cover" data-id="element-117" data-mp="9o2l2n6rwxcl" />
      <div className="absolute inset-0 bg-ink/75" aria-hidden="true" data-id="element-118" data-mp="12ax034ktn4io" />
      <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(23,20,15,0.92)_0%,rgba(23,20,15,0.55)_55%,rgba(23,20,15,0.25)_100%)]" aria-hidden="true" data-id="element-119" data-mp="xkgm9jd39gvs" />

      <div className="relative mx-auto max-w-7xl px-6 py-20 md:py-28 lg:py-36" data-id="element-120" data-mp="sjj7lgraf4z1">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="max-w-2xl" data-id="element-121" data-mp="1q22fjimunusg">
          <p className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3.5 py-1.5 text-xs font-semibold uppercase tracking-[0.14em] text-white/85 backdrop-blur" data-id="element-122" data-mp="3jjd21a0idqlk">
            <MapPin className="h-3.5 w-3.5" aria-hidden="true" data-id="element-123" data-mp="39pcqapaq1n3v" />
            Colorado owned &amp; operated
          </p>

          <h1 className="mt-6 font-heading text-[2.6rem] font-semibold leading-[1.05] tracking-tight text-white sm:text-6xl lg:text-[4.25rem]" data-id="element-124" data-mp="2zt9fkv1t0g5b">
            From foundations to finishes,
            <span className="block text-brand-light" data-id="element-125" data-mp="34pzv9h9p59q7">we&apos;ve got you covered.</span>
          </h1>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/80" data-id="element-126" data-mp="2quxo6qt45ebt">
            From small repairs to full-scale renovations, we handle every project
            with the same care and precision — because we treat your home the way
            our wives expect us to care for ours.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-127" data-mp="rlo489d0y413">
            <a href="#quote" className="group inline-flex items-center justify-center gap-2 rounded-full bg-brand px-7 py-4 text-base font-semibold text-white transition-colors hover:bg-brand-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white" data-id="element-128" data-mp="rmz6g4qtn3q3">
              Book your free quote
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-129" data-mp="1b8c1gsoccp27" />
            </a>
            <a href="#services" className="inline-flex items-center justify-center rounded-full border border-white/25 bg-white/5 px-7 py-4 text-base font-semibold text-white backdrop-blur transition-colors hover:bg-white/15" data-id="element-130" data-mp="16cn6z3r6hycr">
              See all services
            </a>
          </div>

          <dl className="mt-12 grid max-w-lg grid-cols-3 gap-6 border-t border-white/15 pt-8" data-id="element-131" data-mp="1p9occpona0h8">
            {[{
            value: '50+',
            label: 'Years combined experience'
          }, {
            value: '1,200+',
            label: 'Projects restored'
          }, {
            value: '5.0',
            label: 'Average client rating'
          }].map(stat => <div key={stat.label} data-id="element-132" data-mp="26hxrcl65rstg">
                <dt className="sr-only" data-id="element-133" data-mp="26l3ehuv88kmj">{stat.label}</dt>
                <dd className="font-heading text-3xl font-semibold text-white" data-id="element-134" data-mp="2bilg106wzxki">
                  {stat.value}
                </dd>
                <p className="mt-1 text-xs leading-snug text-white/60" data-id="element-135" data-mp="2fhceban49l97">
                  {stat.label}
                </p>
              </div>)}
          </dl>
        </motion.div>
      </div>

      <div className="relative border-t border-white/10 bg-ink/80 backdrop-blur" data-id="element-136" data-mp="2pbbbdv8c2eua">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-10 gap-y-3 px-6 py-4 text-sm text-white/70" data-id="element-137" data-mp="2u7jnezr8hrx8">
          <span className="inline-flex items-center gap-2" data-id="element-138" data-mp="2z5l7no0ebxaa">
            <ShieldCheck className="h-4 w-4 text-brand-light" aria-hidden="true" data-id="element-139" data-mp="339sz3sy8nrc7" />
            Licensed &amp; insured
          </span>
          <span className="inline-flex items-center gap-2" data-id="element-140" data-mp="4q5ddqyof8pc">
            <Star className="h-4 w-4 fill-brand-light text-brand-light" aria-hidden="true" data-id="element-141" data-mp="3vy03o37bluul" />
            5-star rated across the Front Range
          </span>
          <span className="inline-flex items-center gap-2" data-id="element-142" data-mp="9jgow5efodnl">
            <MapPin className="h-4 w-4 text-brand-light" aria-hidden="true" data-id="element-143" data-mp="9k05nisckw01" />
            Parker · Castle Rock · Centennial · Aurora · Lakewood
          </span>
        </div>
      </div>
    </section>;
}